export const extractCertificateExpiry = (base64Cert: string): Date | null => {
  try {
    const binary = atob(base64Cert.replace(/\s/g, ""));
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));

    let pos = 0;
    pos = skipHeader(bytes, pos); // Outer SEQUENCE
    pos = skipHeader(bytes, pos); // TBSCertificate
    if (bytes[pos] === 0xa0) pos = skipElement(bytes, pos); // Version
    pos = skipElement(bytes, pos); // Serial
    pos = skipElement(bytes, pos); // Signature
    pos = skipElement(bytes, pos); // Issuer
    pos = skipHeader(bytes, pos); // Validity SEQUENCE
    pos = skipElement(bytes, pos); // Not Before

    // Read Not After
    const tag = bytes[pos];
    const len = bytes[pos + 1];
    const dateStr = String.fromCharCode(...bytes.slice(pos + 2, pos + 2 + len));

    let year: number, month: number, day: number;
    if (tag === 0x17) {
      // UTCTime
      year =
        parseInt(dateStr.slice(0, 2)) +
        (parseInt(dateStr.slice(0, 2)) >= 50 ? 1900 : 2000);
      month = parseInt(dateStr.slice(2, 4)) - 1;
      day = parseInt(dateStr.slice(4, 6));
    } else {
      // GeneralizedTime
      year = parseInt(dateStr.slice(0, 4));
      month = parseInt(dateStr.slice(4, 6)) - 1;
      day = parseInt(dateStr.slice(6, 8));
    }

    return new Date(year, month, day);
  } catch {
    return null;
  }
};

const skipHeader = (d: Uint8Array, p: number) => {
  p++;
  const len = d[p];
  return p + 1 + (len & 0x80 ? len & 0x7f : 0);
};

const skipElement = (d: Uint8Array, p: number) => {
  p++;
  let len = d[p++];
  if (len & 0x80) {
    const n = len & 0x7f;
    len = 0;
    for (let i = 0; i < n; i++) len = (len << 8) | d[p++];
  }
  return p + len;
};
